import { render, staticRenderFns } from "./EditTooltip.vue?vue&type=template&id=65b57faa&"
import script from "./EditTooltip.vue?vue&type=script&lang=js&"
export * from "./EditTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports